export default {
  "spinner": "_spinner_1dpjtj",
  "primary-a": "_primary-a_1dpjtj",
  "primary-b": "_primary-b_1dpjtj",
  "danger": "_danger_1dpjtj",
  "small": "_small_1dpjtj",
  "medium": "_medium_1dpjtj",
  "large": "_large_1dpjtj"
};